import formatFns from 'date-fns/format';
import ruLocale from 'date-fns/locale/ru';
import onboardingModalImage from 'img/freemium/onboardingModal.png';
import onboardingModalImageDark from 'img/freemium/onboardingModalDark.png';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { useFreemiumExpiresDate } from 'reactApp/hooks/useFreemium';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FreemiumOnboardingModal.css';

export const FreemiumOnboardingModal = ({ onClose }) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const expiresDate = useFreemiumExpiresDate();

    const onShow = useCallback(() => {
        sendDwh({
            eventCategory: 'modal',
            action: 'show',
            dwhData: { name: 'mnz_family_unlimited_soft_freemium_connected' },
            dwh_enabled: true,
        });
    }, []);

    const onModalClose = useCallback(() => {
        sendDwh({
            eventCategory: 'modal',
            action: 'close',
            dwhData: { name: 'mnz_family_unlimited_soft_freemium_connected' },
            dwh_enabled: true,
        });
        onClose?.(onClose);
    }, []);

    const onClick = useCallback(() => {
        sendDwh({
            eventCategory: 'modal',
            action: 'click',
            dwhData: { name: 'mnz_family_unlimited_soft_freemium_connected' },
            dwh_enabled: true,
        });
    }, []);

    let imageAdditionalContent: React.ReactElement | undefined;
    if (expiresDate) {
        const formattedDate = formatFns(expiresDate, 'd.MM', { locale: ruLocale });
        imageAdditionalContent = (
            <div className={styles.imageText}>
                <div className={styles.imageTitle}>
                    256<span className={styles.imageTitleSmall}> ГБ</span>
                </div>
                <div className={styles.imageSubtitle}>Пробная подписка до {formattedDate}</div>
            </div>
        );
    }

    return (
        <WhatsNewDialog
            buttonTheme="vk"
            qaId="freemium-onboarding-modal"
            title={`Вы подключили пробную подписку на 7 дней`}
            imageUrl={isDarkTheme ? onboardingModalImageDark : onboardingModalImage}
            imageAdditionalContent={imageAdditionalContent}
            text="Теперь можно перенести все фото и видео с телефона в Облако и освободить память телефона. Добавьте ещё 3 близких в подписку, чтобы они тоже попробовали"
            textClassName={styles.text}
            primaryButtonText="Хорошо"
            closable
            closeOnEscape
            isRebranding
            closeAfterClick={true}
            onClose={onModalClose}
            onClick={onClick}
            onShow={onShow}
        />
    );
};

FreemiumOnboardingModal.displayName = 'FreemiumOnboardingModal';
